import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/images/icons/link2.svg';
const _hoisted_1 = {
  class: "mt-2 mb-2"
};
const _hoisted_2 = {
  class: "row",
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_3 = {
  class: "col-12"
};
const _hoisted_4 = {
  class: "dashboard-card border-radius-20 pl-4 pr-4 pt-3 pb-5"
};
const _hoisted_5 = {
  class: "w-100 mb-3 mt-2 d-flex justify-content-between"
};
const _hoisted_6 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_7 = {
  class: "d-lg-block d-none"
};
const _hoisted_8 = {
  class: "d-lg-none d-block storage-providers"
};
const _hoisted_9 = {
  class: "d-lg-block d-none"
};
const _hoisted_10 = {
  "element-loading-text": "Loading...",
  style: {
    "min-height": "400px"
  }
};
const _hoisted_11 = {
  class: "d-flex row mt-2 align-items-center ml-1 mr-1 pt-2 pb-2 fs-12",
  style: {
    "border-top": "solid 1px #eeeeee",
    "border-bottom": "solid 1px #eeeeee",
    "color": "#787A9B"
  }
};
const _hoisted_12 = {
  style: {
    "width": "17%"
  },
  class: "text-center"
};
const _hoisted_13 = {
  style: {
    "width": "17%"
  },
  class: "text-center"
};
const _hoisted_14 = {
  style: {
    "width": "15%"
  },
  class: "text-center"
};
const _hoisted_15 = {
  style: {
    "width": "21%"
  },
  class: "text-center"
};
const _hoisted_16 = {
  style: {
    "width": "10%"
  },
  class: "text-center"
};
const _hoisted_17 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  style: {
    "width": "15%"
  },
  class: "text-center cursor-pointer"
};
const _hoisted_21 = {
  style: {
    "width": "21%"
  },
  class: "text-center"
};
const _hoisted_22 = {
  style: {
    "width": "10%"
  },
  class: "text-center"
};
const _hoisted_23 = {
  key: 0,
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_24 = {
  key: 1,
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_25 = {
  class: "d-flex row mt-2 align-items-center ml-1 mr-1 pt-2 pb-2 fs-12",
  style: {
    "border-top": "solid 1px #eeeeee",
    "border-bottom": "solid 1px #eeeeee",
    "color": "#787A9B"
  }
};
const _hoisted_26 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_27 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_28 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_29 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_30 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = ["onClick"];
const _hoisted_33 = {
  style: {
    "width": "20%"
  },
  class: "text-center cursor-pointer"
};
const _hoisted_34 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_35 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_36 = {
  class: "d-flex row mt-2 align-items-center ml-1 mr-1 pt-2 pb-2 fs-12",
  style: {
    "border-top": "solid 1px #eeeeee",
    "border-bottom": "solid 1px #eeeeee",
    "color": "#787A9B"
  }
};
const _hoisted_37 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_38 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_39 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_40 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_41 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = ["onClick"];
const _hoisted_44 = {
  style: {
    "width": "20%"
  },
  class: "text-center cursor-pointer"
};
const _hoisted_45 = ["onClick"];
const _hoisted_46 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_47 = {
  class: "d-flex row mt-2 align-items-center ml-1 mr-1 pt-2 pb-2 fs-12",
  style: {
    "border-top": "solid 1px #eeeeee",
    "border-bottom": "solid 1px #eeeeee",
    "color": "#787A9B"
  }
};
const _hoisted_48 = {
  style: {
    "width": "17%"
  },
  class: "text-center"
};
const _hoisted_49 = {
  style: {
    "width": "17%"
  },
  class: "text-center"
};
const _hoisted_50 = {
  style: {
    "width": "15%"
  },
  class: "text-center"
};
const _hoisted_51 = {
  style: {
    "width": "15%"
  },
  class: "text-center"
};
const _hoisted_52 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_53 = {
  style: {
    "width": "16%"
  },
  class: "text-center"
};
const _hoisted_54 = ["onClick"];
const _hoisted_55 = ["onClick"];
const _hoisted_56 = {
  style: {
    "width": "15%"
  },
  class: "text-center cursor-pointer"
};
const _hoisted_57 = ["onClick"];
const _hoisted_58 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_59 = {
  style: {
    "width": "16%"
  },
  class: "text-center"
};
const _hoisted_60 = {
  class: "d-flex row mt-2 align-items-center ml-1 mr-1 pt-2 pb-2 fs-12",
  style: {
    "border-top": "solid 1px #eeeeee",
    "border-bottom": "solid 1px #eeeeee",
    "color": "#787A9B"
  }
};
const _hoisted_61 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_62 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_63 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_64 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_65 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_66 = ["onClick"];
const _hoisted_67 = {
  style: {
    "width": "20%"
  },
  class: "text-center cursor-pointer"
};
const _hoisted_68 = ["onClick"];
const _hoisted_69 = {
  key: 1,
  style: {
    "width": "20%",
    "line-height": "1"
  },
  class: "flex-center"
};
const _hoisted_70 = ["onClick"];
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", {
  class: "ml-1 mr-1"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "16px"
  },
  alt: ""
})], -1);
const _hoisted_72 = ["onClick"];
const _hoisted_73 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_74 = {
  style: {
    "width": "20%"
  },
  class: "text-center"
};
const _hoisted_75 = {
  class: "d-lg-none d-block"
};
const _hoisted_76 = {
  "element-loading-text": "Loading...",
  style: {
    "min-height": "400px"
  }
};
const _hoisted_77 = {
  class: "d-flex align-items-center justify-content-between"
};
const _hoisted_78 = ["onClick"];
const _hoisted_79 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_80 = ["onClick"];
const _hoisted_81 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_82 = {
  class: "text-center cursor-pointer"
};
const _hoisted_83 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_84 = {
  class: ""
};
const _hoisted_85 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_86 = {
  class: ""
};
const _hoisted_87 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_88 = {
  key: 0,
  class: ""
};
const _hoisted_89 = {
  key: 1,
  class: ""
};
const _hoisted_90 = {
  key: 0,
  style: {
    "width": "100%",
    "height": "1px",
    "background-color": "#eaeaea"
  },
  class: "mt-3"
};
const _hoisted_91 = {
  class: "d-flex align-items-center justify-content-between"
};
const _hoisted_92 = ["onClick"];
const _hoisted_93 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_94 = ["onClick"];
const _hoisted_95 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_96 = {
  class: "text-center cursor-pointer"
};
const _hoisted_97 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_98 = {
  class: ""
};
const _hoisted_99 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_100 = {
  class: ""
};
const _hoisted_101 = {
  key: 0,
  style: {
    "width": "100%",
    "height": "1px",
    "background-color": "#eaeaea"
  },
  class: "mt-3"
};
const _hoisted_102 = {
  class: "d-flex align-items-center justify-content-between"
};
const _hoisted_103 = ["onClick"];
const _hoisted_104 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_105 = ["onClick"];
const _hoisted_106 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_107 = {
  class: "text-center cursor-pointer"
};
const _hoisted_108 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_109 = ["onClick"];
const _hoisted_110 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_111 = {
  class: ""
};
const _hoisted_112 = {
  key: 0,
  style: {
    "width": "100%",
    "height": "1px",
    "background-color": "#eaeaea"
  },
  class: "mt-3"
};
const _hoisted_113 = {
  class: "d-flex align-items-center justify-content-between"
};
const _hoisted_114 = ["onClick"];
const _hoisted_115 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_116 = ["onClick"];
const _hoisted_117 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_118 = {
  class: "text-center cursor-pointer"
};
const _hoisted_119 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_120 = ["onClick"];
const _hoisted_121 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_122 = {
  class: ""
};
const _hoisted_123 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_124 = {
  class: ""
};
const _hoisted_125 = {
  key: 0,
  style: {
    "width": "100%",
    "height": "1px",
    "background-color": "#eaeaea"
  },
  class: "mt-3"
};
const _hoisted_126 = {
  class: "d-flex align-items-center justify-content-between"
};
const _hoisted_127 = ["onClick"];
const _hoisted_128 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_129 = {
  class: "text-center cursor-pointer"
};
const _hoisted_130 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_131 = ["onClick"];
const _hoisted_132 = {
  key: 1,
  class: "d-flex",
  style: {
    "line-height": "1"
  }
};
const _hoisted_133 = ["onClick"];
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", {
  class: "ml-1 mr-1"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "16px"
  },
  alt: ""
})], -1);
const _hoisted_135 = ["onClick"];
const _hoisted_136 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_137 = {
  class: ""
};
const _hoisted_138 = {
  class: "d-flex align-items-center justify-content-between mt-2"
};
const _hoisted_139 = {
  class: ""
};
const _hoisted_140 = {
  key: 0,
  style: {
    "width": "100%",
    "height": "1px",
    "background-color": "#eaeaea"
  },
  class: "mt-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('farm.console.History')), 1)]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_radio_group, {
    modelValue: $data.radio,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.radio = $event),
    onChange: $options.eventChange
  }, {
    default: _withCtx(() => [_createVNode(_component_el_radio, {
      label: 1
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('subpool.Borrows')), 1)]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: 4
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.Loan withdrawal btn')), 1)]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: 3
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('subpool.Withdraws')), 1)]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: 2
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.Repayments')), 1)]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: 5
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.Action')), 1)]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_select, {
    modelValue: $data.radio,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.radio = $event),
    onChange: $options.eventChange,
    placeholder: "Select",
    size: "large"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_option, {
      label: _ctx.$t('subpool.Borrows'),
      value: 1
    }, null, 8, ["label"]), _createVNode(_component_el_option, {
      label: _ctx.$t('farm.console.Loan withdrawal btn'),
      value: 4
    }, null, 8, ["label"]), _createVNode(_component_el_option, {
      label: _ctx.$t('subpool.Withdraws'),
      value: 3
    }, null, 8, ["label"]), _createVNode(_component_el_option, {
      label: _ctx.$t('farm.console.Repayments'),
      value: 2
    }, null, 8, ["label"]), _createVNode(_component_el_option, {
      label: _ctx.$t('farm.console.Action'),
      value: 5
    }, null, 8, ["label"])]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_9, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [$data.radio === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('farm.console.TxnHash')), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('farm.console.From')), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('farm.console.Age')), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('farm.console.Amount')), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('farm.console.Mode')), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('farm.console.Rate')), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "d-flex mb-3 mt-4",
      key: index
    }, [_createElementVNode("div", {
      style: {
        "width": "17%"
      },
      class: "text-center link-text-ordinary",
      onClick: $event => $options.gotoHash(item.hash, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.hash, 6, 6)), 9, _hoisted_18), _createElementVNode("div", {
      style: {
        "width": "17%"
      },
      class: "text-center link-text-ordinary",
      onClick: $event => $options.gotoAddress(item.user, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.user, 6, 6)), 9, _hoisted_19), _createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: $options.getByBlockNumberToTime(item.tipset),
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_20, _toDisplayString($options.calcAge(item.tipset)), 1)]),
      _: 2
    }, 1032, ["content"]), _createElementVNode("div", _hoisted_21, _toDisplayString($options.externalFormatFilPrice(item.amount)), 1), _createElementVNode("div", _hoisted_22, _toDisplayString(item.rate_mode === 2 ? _ctx.$t('farm.console.Variable') : _ctx.$t('farm.console.Stable')), 1), item.rate_mode === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString($options.formatPrice($options.formatUnits(item.borrow_rate, 25), 6)) + "% ", 1)) : _createCommentVNode("", true), item.rate_mode !== 1 ? (_openBlock(), _createElementBlock("div", _hoisted_24, " -- ")) : _createCommentVNode("", true)]);
  }), 128))], 64)) : _createCommentVNode("", true), $data.radio === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('farm.console.TxnHash')), 1), _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('farm.console.From')), 1), _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('farm.console.Age')), 1), _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('farm.console.Amount')), 1), _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('farm.console.Mode')), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "d-flex mb-3 mt-4",
      key: index
    }, [_createElementVNode("div", {
      style: {
        "width": "20%"
      },
      class: "text-center link-text-ordinary",
      onClick: $event => $options.gotoHash(item.hash, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.hash, 6, 6)), 9, _hoisted_31), _createElementVNode("div", {
      style: {
        "width": "20%"
      },
      class: "text-center link-text-ordinary",
      onClick: $event => $options.gotoAddress(item.user, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.user, 6, 6)), 9, _hoisted_32), _createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: $options.getByBlockNumberToTime(item.tipset),
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_33, _toDisplayString($options.calcAge(item.tipset)), 1)]),
      _: 2
    }, 1032, ["content"]), _createElementVNode("div", _hoisted_34, _toDisplayString($options.externalFormatFilPrice(item.amount)), 1), _createElementVNode("div", _hoisted_35, _toDisplayString(item.repay_rate_mode === 2 ? _ctx.$t('farm.console.Variable') : _ctx.$t('farm.console.Stable')), 1)]);
  }), 128))], 64)) : _createCommentVNode("", true), $data.radio === 3 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('farm.console.TxnHash')), 1), _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('farm.console.From')), 1), _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('farm.console.Age')), 1), _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('farm.console.To')), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('farm.console.Amount')), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "d-flex mb-3 mt-4",
      key: index
    }, [_createElementVNode("div", {
      style: {
        "width": "20%"
      },
      class: "text-center link-text-ordinary",
      onClick: $event => $options.gotoHash(item.hash, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.hash, 6, 6)), 9, _hoisted_42), _createElementVNode("div", {
      style: {
        "width": "20%"
      },
      class: "text-center link-text-ordinary",
      onClick: $event => $options.gotoAddress(item.user, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.user, 6, 6)), 9, _hoisted_43), _createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: $options.getByBlockNumberToTime(item.tipset),
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_44, _toDisplayString($options.calcAge(item.tipset)), 1)]),
      _: 2
    }, 1032, ["content"]), _createElementVNode("div", {
      style: {
        "width": "20%"
      },
      class: "text-center link-text-ordinary",
      onClick: $event => $options.gotoAddress($options.toOwner(item.to), _ctx.$i18n.locale)
    }, _toDisplayString($options.toOwner(item.to)), 9, _hoisted_45), _createElementVNode("div", _hoisted_46, _toDisplayString($options.externalFormatFilPrice(item.amount)), 1)]);
  }), 128))], 64)) : _createCommentVNode("", true), $data.radio === 4 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('farm.console.TxnHash')), 1), _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('farm.console.From')), 1), _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('farm.console.Age')), 1), _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('farm.console.To')), 1), _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('farm.console.Amount')), 1), _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('farm.console.Award')), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "d-flex mb-3 mt-4",
      key: index
    }, [_createElementVNode("div", {
      style: {
        "width": "17%"
      },
      class: "text-center link-text-ordinary",
      onClick: $event => $options.gotoHash(item.hash, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.hash, 6, 6)), 9, _hoisted_54), _createElementVNode("div", {
      style: {
        "width": "17%"
      },
      class: "text-center link-text-ordinary",
      onClick: $event => $options.gotoAddress(item.user, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.user, 6, 6)), 9, _hoisted_55), _createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: $options.getByBlockNumberToTime(item.tipset),
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_56, _toDisplayString($options.calcAge(item.tipset)), 1)]),
      _: 2
    }, 1032, ["content"]), _createElementVNode("div", {
      style: {
        "width": "15%"
      },
      class: "text-center link-text-ordinary",
      onClick: $event => $options.gotoAddress($options.toOwner(item.on_behalf_of), _ctx.$i18n.locale)
    }, _toDisplayString($options.toOwner(item.on_behalf_of)), 9, _hoisted_57), _createElementVNode("div", _hoisted_58, _toDisplayString($options.externalFormatFilPrice(item.amount)), 1), _createElementVNode("div", _hoisted_59, _toDisplayString($options.externalFormatFilPrice(item.award)), 1)]);
  }), 128))], 64)) : _createCommentVNode("", true), $data.radio === 5 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 4
  }, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t('farm.console.TxnHash')), 1), _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t('farm.console.Age')), 1), _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('farm.console.actorId')), 1), _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t('farm.console.role')), 1), _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t('farm.console.action')), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "d-flex mb-3 mt-4",
      key: index
    }, [_createElementVNode("div", {
      style: {
        "width": "20%"
      },
      class: "text-center link-text-ordinary",
      onClick: $event => $options.gotoHash(item.hash, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.hash, 6, 6)), 9, _hoisted_66), _createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: $options.getByBlockNumberToTime(item.tipset),
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_67, _toDisplayString($options.calcAge(item.tipset)), 1)]),
      _: 2
    }, 1032, ["content"]), item.event !== 'ProvideGuarantee' && item.event !== 'TerminateGuarantee' ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      style: {
        "width": "20%"
      },
      class: "text-center link-text-ordinary",
      onClick: $event => $options.gotoAddress(`f0${item.actor_id}`, _ctx.$i18n.locale)
    }, "f0" + _toDisplayString(item.actor_id), 9, _hoisted_68)) : _createCommentVNode("", true), item.event === 'ProvideGuarantee' || item.event === 'TerminateGuarantee' ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoAddress(`f0${item.g_actor_id}`, _ctx.$i18n.locale)
    }, " f0" + _toDisplayString(item.g_actor_id), 9, _hoisted_70), _hoisted_71, _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoAddress(`f0${item.actor_id}`, _ctx.$i18n.locale)
    }, " f0" + _toDisplayString(item.actor_id), 9, _hoisted_72)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_73, _toDisplayString($options.roleLabel(item.role, item.event)), 1), _createElementVNode("div", _hoisted_74, _toDisplayString($options.actionLabel(item.event)), 1)]);
  }), 128))], 64)) : _createCommentVNode("", true)])), [[_directive_loading, $data.loading]])]), _createElementVNode("div", _hoisted_75, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_76, [$data.radio === 1 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.history, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "mb-3 mt-4 pl-2 pr-2 fsi-14",
      key: index
    }, [_createElementVNode("div", _hoisted_77, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.TxnHash')), 1), _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoHash(item.hash, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.hash, 6, 6)), 9, _hoisted_78)]), _createElementVNode("div", _hoisted_79, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.From')), 1), _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoAddress(item.user, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.user, 6, 6)), 9, _hoisted_80)]), _createElementVNode("div", _hoisted_81, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Age')), 1), _createElementVNode("div", null, [_createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: $options.getByBlockNumberToTime(item.tipset),
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_82, _toDisplayString($options.calcAge(item.tipset)), 1)]),
      _: 2
    }, 1032, ["content"])])]), _createElementVNode("div", _hoisted_83, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Amount')), 1), _createElementVNode("div", _hoisted_84, _toDisplayString($options.externalFormatFilPrice(item.amount)), 1)]), _createElementVNode("div", _hoisted_85, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Mode')), 1), _createElementVNode("div", _hoisted_86, _toDisplayString(item.rate_mode === 2 ? _ctx.$t('farm.console.Variable') : _ctx.$t('farm.console.Stable')), 1)]), _createElementVNode("div", _hoisted_87, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Rate')), 1), item.rate_mode === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString($options.formatPrice($options.formatUnits(item.borrow_rate, 25), 6)) + "%", 1)) : _createCommentVNode("", true), item.rate_mode !== 1 ? (_openBlock(), _createElementBlock("div", _hoisted_89, "--")) : _createCommentVNode("", true)]), index < _ctx.history.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_90)) : _createCommentVNode("", true)]);
  }), 128)) : _createCommentVNode("", true), $data.radio === 2 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList(_ctx.history, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "mb-3 mt-4 pl-2 pr-2 fsi-14",
      key: index
    }, [_createElementVNode("div", _hoisted_91, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.TxnHash')), 1), _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoHash(item.hash, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.hash, 6, 6)), 9, _hoisted_92)]), _createElementVNode("div", _hoisted_93, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.From')), 1), _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoAddress(item.user, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.user, 6, 6)), 9, _hoisted_94)]), _createElementVNode("div", _hoisted_95, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Age')), 1), _createElementVNode("div", null, [_createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: $options.getByBlockNumberToTime(item.tipset),
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_96, _toDisplayString($options.calcAge(item.tipset)), 1)]),
      _: 2
    }, 1032, ["content"])])]), _createElementVNode("div", _hoisted_97, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Amount')), 1), _createElementVNode("div", _hoisted_98, _toDisplayString($options.externalFormatFilPrice(item.amount)), 1)]), _createElementVNode("div", _hoisted_99, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Mode')), 1), _createElementVNode("div", _hoisted_100, _toDisplayString(item.repay_rate_mode === 2 ? _ctx.$t('farm.console.Variable') : _ctx.$t('farm.console.Stable')), 1)]), index < _ctx.history.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_101)) : _createCommentVNode("", true)]);
  }), 128)) : _createCommentVNode("", true), $data.radio === 3 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 2
  }, _renderList(_ctx.history, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "mb-3 mt-4 pl-2 pr-2 fsi-14",
      key: index
    }, [_createElementVNode("div", _hoisted_102, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.TxnHash')), 1), _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoHash(item.hash, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.hash, 6, 6)), 9, _hoisted_103)]), _createElementVNode("div", _hoisted_104, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.From')), 1), _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoAddress(item.user, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.user, 6, 6)), 9, _hoisted_105)]), _createElementVNode("div", _hoisted_106, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Age')), 1), _createElementVNode("div", null, [_createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: $options.getByBlockNumberToTime(item.tipset),
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_107, _toDisplayString($options.calcAge(item.tipset)), 1)]),
      _: 2
    }, 1032, ["content"])])]), _createElementVNode("div", _hoisted_108, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.To')), 1), _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoAddress($options.toOwner(item.to, _ctx.$i18n.locale))
    }, _toDisplayString($options.toOwner(item.to)), 9, _hoisted_109)]), _createElementVNode("div", _hoisted_110, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Amount')), 1), _createElementVNode("div", _hoisted_111, _toDisplayString($options.externalFormatFilPrice(item.amount)), 1)]), index < _ctx.history.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_112)) : _createCommentVNode("", true)]);
  }), 128)) : _createCommentVNode("", true), $data.radio === 4 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 3
  }, _renderList(_ctx.history, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "mb-3 mt-4 pl-2 pr-2 fsi-14",
      key: index
    }, [_createElementVNode("div", _hoisted_113, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.TxnHash')), 1), _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoHash(item.hash, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.hash, 6, 6)), 9, _hoisted_114)]), _createElementVNode("div", _hoisted_115, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.From')), 1), _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoAddress(item.user, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.user, 6, 6)), 9, _hoisted_116)]), _createElementVNode("div", _hoisted_117, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Age')), 1), _createElementVNode("div", null, [_createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: $options.getByBlockNumberToTime(item.tipset),
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_118, _toDisplayString($options.calcAge(item.tipset)), 1)]),
      _: 2
    }, 1032, ["content"])])]), _createElementVNode("div", _hoisted_119, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.To')), 1), _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoAddress($options.toOwner(item.on_behalf_of), _ctx.$i18n.locale)
    }, _toDisplayString($options.toOwner(item.on_behalf_of)), 9, _hoisted_120)]), _createElementVNode("div", _hoisted_121, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Amount')), 1), _createElementVNode("div", _hoisted_122, _toDisplayString($options.externalFormatFilPrice(item.amount)), 1)]), _createElementVNode("div", _hoisted_123, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Award')), 1), _createElementVNode("div", _hoisted_124, _toDisplayString($options.externalFormatFilPrice(item.award)), 1)]), index < _ctx.history.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_125)) : _createCommentVNode("", true)]);
  }), 128)) : _createCommentVNode("", true), $data.radio === 5 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 4
  }, _renderList(_ctx.history, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "mb-3 mt-4 pl-2 pr-2 fsi-14",
      key: index
    }, [_createElementVNode("div", _hoisted_126, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.TxnHash')), 1), _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoHash(item.hash, _ctx.$i18n.locale)
    }, _toDisplayString($options.simpleValue(item.hash, 6, 6)), 9, _hoisted_127)]), _createElementVNode("div", _hoisted_128, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Age')), 1), _createElementVNode("div", null, [_createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: $options.getByBlockNumberToTime(item.tipset),
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_129, _toDisplayString($options.calcAge(item.tipset)), 1)]),
      _: 2
    }, 1032, ["content"])])]), _createElementVNode("div", _hoisted_130, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.actorId')), 1), item.event !== 'ProvideGuarantee' && item.event !== 'TerminateGuarantee' ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "link-text-ordinary",
      onClick: $event => $options.gotoAddress(`f0${item.actor_id}`, _ctx.$i18n.locale)
    }, "f0" + _toDisplayString(item.actor_id), 9, _hoisted_131)) : _createCommentVNode("", true), item.event === 'ProvideGuarantee' || item.event === 'TerminateGuarantee' ? (_openBlock(), _createElementBlock("div", _hoisted_132, [_createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoAddress(`f0${item.g_actor_id}`, _ctx.$i18n.locale)
    }, "f0" + _toDisplayString(item.g_actor_id), 9, _hoisted_133), _hoisted_134, _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: $event => $options.gotoAddress(`f0${item.actor_id}`, _ctx.$i18n.locale)
    }, "f0" + _toDisplayString(item.actor_id), 9, _hoisted_135)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_136, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.role')), 1), _createElementVNode("div", _hoisted_137, _toDisplayString($options.roleLabel(item.role, item.event)), 1)]), _createElementVNode("div", _hoisted_138, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.action')), 1), _createElementVNode("div", _hoisted_139, _toDisplayString($options.actionLabel(item.event)), 1)]), index < _ctx.history.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_140)) : _createCommentVNode("", true)]);
  }), 128)) : _createCommentVNode("", true)])), [[_directive_loading, $data.loading]])])])])])]);
}